/* @ngInject */
function GeneralSettingsController ($scope, $timeout, $rootScope, $translate, Utils, GeneralSettingsService, CustomerConfigurationsService, CONSTANTS, InitializerService, UdsModalService, MessageService, ToastService) {
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

  $scope.models = {
    aBooleanConfigurations: {},
    aStringConfigurations: {},
    aTimestampConfigurations: {}
  }

  $scope.field = {}
  $scope.loading = true
  $scope.hours = [
    '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
    '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
  ]
  $scope.editSupportEmail = false
  $scope.backgroundSrc = ''

  $scope.companyFeatures = {
    multiFactorAuth: false,
    strongPasswordAccess: false,
    passwordExpiration: false,
    artsCustomization: true
  }
  $scope.showTimesheetCheckbox = false
  $scope.showManagersCheckbox = false

  const api = {
    getUpgradeCompanyPlanDialogController,
    _getConfigurations,
    activate
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUserCompany().then(() => {
      api._getConfigurations()

      $rootScope.getCompanyFeaturesAndAddons().then(({ features, pricingPackageId }) => {
        $scope.features = features
        $scope.companyFeatures.multiFactorAuth = !!features[String('GENERAL.MULTI_FACTOR_AUTHENTICATION')]
        $scope.companyFeatures.strongPasswordAccess = !!features[String('GENERAL.STRONG_PASSWORD_ACCESS')]
        $scope.companyFeatures.passwordExpiration = !!features[String('GENERAL.PASSWORD_EXPIRATION')]
        $scope.companyFeatures.artsCustomization = !!features[String('ARTS.CUSTOMIZABLE_ARTS')]
        $scope.showTimesheetCheckbox = pricingPackageId === 4 && !!features[String('WORKFLOW.ACCESS')]

        $rootScope.getCompanyConfigurations().then(configurations => {
          $scope.showManagersCheckbox = pricingPackageId !== 4 || configurations?.ENABLE_MANAGERS
        })
      })
    })
  }

  $scope.isEndHourGreater = function () {
    if (!$scope || !$scope.models || !$scope.models.aIntegerConfigurations) {
      return true
    }

    const value = $scope.models.aIntegerConfigurations.BUSINESS_END_HOUR > $scope.models.aIntegerConfigurations.BUSINESS_START_HOUR
    if (!value) {
      $('.dropdown').addClass('warning')
    } else {
      $('.dropdown').removeClass('warning')
    }

    return value
  }

  $scope.disableSaveButton = () => {
    if (!$scope.models.aBooleanConfigurations.ENABLE_BUSINESS_HOURS) {
      return angular.equals($scope.models, $scope.oSavedConfigurations)
    }

    return angular.equals($scope.models, $scope.oSavedConfigurations) || !$scope.isEndHourGreater()
  }

  $scope.updateConfigurations = () => {
    $scope.loading = true
    CustomerConfigurationsService.updateAllConfigurations(_mapModels($scope.models))
      .then(_handleConfigurationsReceived)
      .then(() => {
        $rootScope.customerColor = $scope.models.aStringConfigurations.COMPANY_PRIMARY_COLOR
        CustomerConfigurationsService.getAllConfigurations().then(configurations => InitializerService.sucessCallbackGetUserCompanyConfigurations(configurations))
      })
  }

  $scope.resetConfigurations = () => {
    api._getConfigurations()
  }

  $scope.openSpectrum = function (event) {
    const palette = [{
      name: $translate.instant('defaultPalette'),
      colors: ['#000', '#444', '#808080', '#9b9b9b', '#d7d7d7', '#fff', '#A5673F', '#db2828', '#F2711C', '#FBBD08', '#fff400', '#B5CC18', '#21BA45', '#00B5AD', '#2185D0', '#050080', '#A333C8', '#E03997']
    }]
    const colorToChange = $(event.target)

    const oldColor = event.target.style['background-color']

    function updateColor (color) {
      $scope.models.aStringConfigurations.COMPANY_PRIMARY_COLOR = color

      if (!$scope.$$phase) {
        $scope.$apply()
      }
    }

    colorToChange.spectrum('destroy')
    colorToChange.spectrum({
      showInput: true,
      color: oldColor,
      preferredFormat: 'hex',
      chooseText: $translate.instant('apply'),
      cancelText: $translate.instant('cancel'),
      containerClassName: 'colorPickerFlimbo',
      showPalette: true,
      customPalette: palette,
      palette,
      clickoutFiresChange: false,
      change: function (color) {
        updateColor(color.toHexString())
      },
      move: function (color) {
        updateColor(color.toHexString())
      },
      hide: function (color) {
        updateColor(color.toHexString())
        colorToChange.spectrum('destroy')
      }
    })

    requestAnimationFrame(() => {
      colorToChange.spectrum('show')
    })
  }

  $scope.editableField = field => {
    $scope[field] = !$scope[field]
  }

  $scope.getLogoSrc = function () {
    if (!$rootScope.oUser || !$rootScope.oUser.customerCompanyId) {
      return ''
    }

    return $rootScope.getCustomerLogo()
  }

  $scope.getLogoColoredSrc = function () {
    if (!$rootScope.oUser || !$rootScope.oUser.customerCompanyId) {
      return ''
    }

    return $rootScope.getCustomerLogoColor()
  }

  $scope.getSymbolColoredSrc = function () {
    if (!$rootScope.oUser || !$rootScope.oUser.customerCompanyId) {
      return ''
    }

    return $rootScope.getCustomerSymbolColor()
  }

  $scope.getLoginLogoSrc = function () {
    if (!$rootScope.oUser || !$rootScope.oUser.customerCompanyId) {
      return ''
    }

    return $rootScope.getCustomerLoginLogo($scope.company)
  }

  $scope.getBackgroundImageSrc = function () {
    if (!$rootScope.oUser || !$rootScope.oUser.customerCompanyId) {
      return ''
    }

    return $rootScope.getCustomerBackground($scope.company)
  }

  $scope.uploadLogo = files => {
    GeneralSettingsService.uploadCompanyLogo(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO, files)
      .then(() => {
        MessageService.success({
          title: 'successTitle',
          confirmButtonText: 'ok',
          press: () => {
            window.location.reload()
          }
        })
      }).catch(ToastService.defaultErrorToast)
  }

  $scope.uploadLogoColored = files => {
    GeneralSettingsService.uploadCompanyLogo(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_COLORED, files)
      .then(() => {
        MessageService.success({
          title: 'successTitle',
          confirmButtonText: 'ok',
          press: () => {
            window.location.reload()
          }
        })
      }).catch(ToastService.defaultErrorToast)
  }

  $scope.uploadSymbolColored = files => {
    GeneralSettingsService.uploadCompanyLogo(CONSTANTS.URL_CUSTOMER_COMPANY_SYMBOL_COLORED, files)
      .then(() => {
        MessageService.success({
          title: 'successTitle',
          confirmButtonText: 'ok',
          press: () => {
            window.location.reload()
          }
        })
      }).catch(ToastService.defaultErrorToast)
  }

  $scope.uploadLoginLogo = files => {
    GeneralSettingsService.uploadCompanyLogo(CONSTANTS.URL_CUSTOMER_COMPANY_LOGO_LOGIN, files)
      .then(() => {
        MessageService.success({
          title: 'successTitle',
          confirmButtonText: 'ok',
          press: () => {
            window.location.reload()
          }
        })
      }).catch(ToastService.defaultErrorToast)
  }

  $scope.uploadCustomBackground = files => {
    GeneralSettingsService.uploadCompanyBackground(CONSTANTS.URL_CUSTOMER_COMPANY_BACKGROUND, files)
      .then(() => {
        MessageService.success({
          title: 'successTitle',
          confirmButtonText: 'ok',
          press: () => {
            window.location.reload()
          }
        })
      }).catch(ToastService.defaultErrorToast)
  }

  $scope.validSupportEmail = () => {
    return GeneralSettingsService.validSupportEmail($scope.models.aStringConfigurations.SUPPORT_EMAIL)
  }

  $scope.openPricingDialog = (type) => {
    const names = {
      strongPassword: $translate.instant('billingFeatures.strongPasswordAccess'),
      mfa: $translate.instant('billingFeatures.multiFactorAuthentication'),
      passwordExpiration: $translate.instant('billingFeatures.passwordExpiration')
    }

    const slugs = {
      strongPassword: 'GENERAL.STRONG_PASSWORD_ACCESS',
      mfa: 'GENERAL.MULTI_FACTOR_AUTHENTICATION',
      passwordExpiration: 'GENERAL.PASSWORD_EXPIRATION'
    }

    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName: names[type],
          featureSlug: slugs[type]
        }
      })

      upgradeCompanyPlanDialog.open()
    })
  }

  function _mapArrayToObject (array) {
    return array.reduce((obj, item) => {
      if (obj.id) {
        return Object.assign({}, { [obj.type]: obj.value }, { [item.type]: item.value })
      }
      return Object.assign({}, obj, { [item.type]: item.value })
    }, {})
  }

  $scope.valueOfModule = value => {
    if (typeof value === 'string') {
      if (value.search(/:/) && value.search(/:/) !== -1) {
        value = (parseInt(value.substring(0, 2), 10) * 60) + parseInt(value.substring(3, 5), 10)
      }
    }

    return value
  }

  $scope.validInput = attribute => {
    return $scope.company && typeof $scope.company[attribute] === 'number' && $scope.company[attribute] > 0
  }

  function _mapObjectToArray (configurations) {
    const configurationsArray = Object.entries(configurations)
    const config = configurationsArray.map(configuration => {
      const value = $scope.valueOfModule(configuration[1])

      return {
        type: configuration[0],
        value
      }
    })

    return config
  }

  function _mapModels (models) {
    const newObject = {}
    for (const key in models) {
      newObject[key] = _mapObjectToArray(models[key])
    }
    return newObject
  }

  function _handleConfigurationsReceived (oConfigurations) {
    let key = ''
    const keysToParseAsTime = ['BUSINESS_START_HOUR', 'BUSINESS_END_HOUR']
    for (key in oConfigurations.aIntegerConfigurations) {
      const configType = oConfigurations.aIntegerConfigurations[key].type

      if (keysToParseAsTime.includes(configType)) {
        oConfigurations.aIntegerConfigurations[key].value = Utils.parseTimeFromInteger(oConfigurations.aIntegerConfigurations[key].value)
      }
    }

    for (key in oConfigurations) {
      $scope.models[key] = _mapArrayToObject(oConfigurations[key])
    }

    $scope.loading = false
    $scope.models.aStringConfigurations.COMPANY_PRIMARY_COLOR = $scope.models.aStringConfigurations.COMPANY_PRIMARY_COLOR || $rootScope.customerColor
    $scope.oSavedConfigurations = Utils.cloneObject($scope.models)

    $timeout(() => {
      $scope.company = Object.assign({}, $rootScope.oUserCompany)
    }, 0)

    if (!$scope.$$phase) {
      $scope.$apply()
    }
  }

  function _getConfigurations () {
    CustomerConfigurationsService.getAllConfigurations()
      .then(configurations => {
        InitializerService.sucessCallbackGetUserCompanyConfigurations(configurations)
        _handleConfigurationsReceived(configurations)
        $timeout(() => {
          $('.dropdown-context').dropdown()
        }, 1500, false)
      })
  }

  requestAnimationFrame(function () {
    $('.from-dropdown').dropdown()
    $('.to-dropdown').dropdown()
  })
}

export { GeneralSettingsController }
